import { Accordion } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            boxShadow: 'none',
            backgroundColor: 'transparent',
            borderBottom: '2px solid #E9E9E9',
            '& .MuiAccordionSummary-root': {
                padding: 0,
                minHeight: theme.spacing(5),
            },
            '& .MuiAccordionSummary-root.Mui-expanded': {
                height: theme.spacing(5),
            },
            '& .MuiAccordionSummary-content.Mui-expanded': {
                margin: theme.spacing(1, 0),
            },
            '& .MuiAccordionSummary-content ': {
                margin: theme.spacing(1, 0),
            },
            '& .MuiAccordionDetails-root': {
                padding: 0,
            },
            '&::before': {
                height: 0,
            },
        },
    };
});

const CustomAccordion = (props) => {
    const { ...rest } = props;
    const { classes, cx } = useStyles();
    return <Accordion {...rest} className={cx(classes.root, rest.className)} />;
};

export default CustomAccordion;
